import { Controller } from '@hotwired/stimulus'

export default class HelperController extends Controller {
  static targets = ['emojiShow']

  emojiShowTargetConnected(element) {
    for (const emoji of element.querySelectorAll('.ql-emoji')) {
      const url = emoji.dataset.url
      if (!url) return

      emoji.style.backgroundImage = `url("${url}")`
      emoji.style.backgroundRepeat = 'no-repeat'
      emoji.style.position = 'relative'
    }
  }
}
